import {
  COOKIE_CATEGORIES,
  hasCookieConsentFor,
} from "./cookieConsent";

const GTM_CONTAINER_ID = "GTM-57JTJT9M";
let analyticsInitialized = false;

const injectGtmScript = () => {
  if (document.querySelector(`script[src*="gtm.js?id=${GTM_CONTAINER_ID}"]`)) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`;
  document.head.appendChild(script);
};

const setDefaultConsent = () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("consent", "default", {
    ad_storage: "denied",
    analytics_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
};

const updateConsent = (analyticsAllowed) => {
  if (!window.gtag) return;

  window.gtag("consent", "update", {
    analytics_storage: analyticsAllowed ? "granted" : "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
};

const initializeGtm = () => {
  if (analyticsInitialized) return;

  setDefaultConsent();
  injectGtmScript();

  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });
  analyticsInitialized = true;
};

const shouldEnableAnalytics = () =>
  hasCookieConsentFor(COOKIE_CATEGORIES.ANALYTICS);

export const setupAnalyticsByConsent = () => {
  initializeGtm();
  updateConsent(shouldEnableAnalytics());

  window.addEventListener("cookie-consent-updated", () => {
    updateConsent(shouldEnableAnalytics());
  });
};
